import { createSelector } from 'reselect'
import _ from 'underscore'

const getPaymentMethods = (state) => state.user.paymentMethods

export const getMollieMethod = createSelector(
  [getPaymentMethods],
  (paymentMethods) => paymentMethods.find(method => method.type === 'MOLLIE')
)
